import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-oc-beige flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <div className="eyebrow text-oc-coral mb-6">404</div>
        <h1 className="font-editorial text-5xl md:text-6xl text-oc-ink leading-tight">
          The page you were looking for isn't in the archive.
        </h1>
        <p className="mt-6 font-editorial text-lg text-oc-ink-soft">
          Try the archive, or head home.
        </p>
        <div className="mt-10 flex gap-4 justify-center">
          <Link to="/" className="h-12 px-6 border border-oc-ink font-ui text-xs font-bold uppercase tracking-widest flex items-center hover:bg-oc-ink hover:text-white">Home</Link>
          <Link to="/interviews" className="h-12 px-6 bg-oc-blue text-white font-ui text-xs font-bold uppercase tracking-widest flex items-center hover:bg-oc-blue-hover">Interviews</Link>
        </div>
      </div>
    </div>
  );
}
